import { PayloadAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { authReducer } from './auth/auth.reducer';
import { AUTH_ACTION_TYPES } from './auth/auth.types';
import { errorReducer } from './error/error.reducer';
import { loadingReducer } from './loading/loading.reducer';

const appReducer = combineReducers({
    loading: loadingReducer,
    error: errorReducer,
    auth: authReducer,
});

export const rootReducer = (state: any, action: PayloadAction) => {
    if (action.type === AUTH_ACTION_TYPES.SIGN_OUT) {
        state = undefined;
    }


    return appReducer(state, action);
};
